module.exports = __webpack_public_path__ + "img/kelapa-tacunan.e1530a49.jpeg";